import React from 'react';
import { BaseComponent } from "../../../../project/general";
import { render } from "preact";
import { ToggleButton } from "../../toggle-button";

class TimelineDecadeComponent extends BaseComponent {

    static getRequiredRefs() {
        return ["backgroundTogglePlaceholder"];
    }

    static getNamespace() {
        return 'heritage-timeline-decade';
    }

    background = null;
    decadeSelect = null;
    bgImgToggle = null;
    selectedItem = null;

    cacheDomElements() {
        this.background = document.querySelector(".ah-container");
        this.decadeSelect = document.querySelector(".ah-decade-select select");
    }

    showItem(index, items) {
        items.forEach((item, i) => {
            const isActive = i === index;
            item.style.display = isActive ? "flex" : "none";
            if (isActive) {
                this.selectedItem = item;
                this.showOrHideBackgroundImage();
            }
        });
    }

    updateQueryParam(decade) {
        const url = new URL(window.location.href);
        url.searchParams.set("decade", decade);
        window.history.replaceState({}, "", url);
    }

    setActiveDecadeButton(index) {
        const buttons = document.querySelectorAll(".decade-button");
        buttons.forEach(btn => btn.classList.remove("active"));
        if (buttons[index]) {
            buttons[index].classList.add("active");
        }
    }

    onScript() {
        const items = document.querySelectorAll(".item");
        const buttons = document.querySelectorAll(".decade-button");

        const urlParams = new URLSearchParams(window.location.search);
        const queryDecade = urlParams.get("decade");

        buttons.forEach((button, index) => {
            const decade = button.dataset.decade;

            button.addEventListener("click", () => {
                this.showItem(index, items);
                this.setActiveDecadeButton(index);
                this.updateQueryParam(decade);
            });
        });

        let defaultIndex = 0;

        if (queryDecade) {
            buttons.forEach((button, index) => {
                if (button.dataset.decade === queryDecade) {
                    defaultIndex = index;
                }
            });
        }

        this.showItem(defaultIndex, items);
        this.setActiveDecadeButton(defaultIndex);

        if (this.decadeSelect) {
            this.decadeSelect.addEventListener("change", (event) => {
                const index = event.target.selectedIndex;
                const selectedDecade = buttons[index]?.dataset.decade;
                this.showItem(index, items);
                this.setActiveDecadeButton(index);
                if (selectedDecade) this.updateQueryParam(selectedDecade);
            });
        }

        this.renderToggleButton();
    }



    renderToggleButton = () => {
        const { trueText, falseText } = this.refs.backgroundTogglePlaceholder.dataset;


        render(
            <ToggleButton
                value={this.backgroundImageIsVisible()}
                onToggle={this.toggleShowBackgroundImage}
                trueText={trueText}
                falseText={falseText}
            />,
            this.refs.backgroundTogglePlaceholder
        );
    }

    backgroundImageIsVisible = () => {
        return localStorage.getItem("showBackgroundImage") === "true";
    }

    toggleShowBackgroundImage = () => {
        const value = !this.backgroundImageIsVisible();
        localStorage.setItem("showBackgroundImage", value);
        this.showOrHideBackgroundImage();
        return value;
    }

    showOrHideBackgroundImage() {
        const input = this.selectedItem?.querySelector('input');
        if (input && this.background && this.backgroundImageIsVisible()) {
            this.background.style.setProperty('--dynamic-bg', `url(${input.value})`);
        } else {
            this.background.style.setProperty('--dynamic-bg', 'none');
        }
    }

    onInit() {
        this.cacheDomElements();
        this.onScript();
    }
}

export default TimelineDecadeComponent;
